<div class="aig-login p-flexcc u-height-vh-100">
  <div class="u-border u-radius-2 u-p-7 aig-login__wrap">
    <div class="p-flexcc u-dir-col">
      <img
        src="./assets/images/logos/logo.svg"
        alt="logo_aig"
        loading="lazy"
      />

      <p class="u-fs-40 u-color-primary1 u-mt-7">Iniciar sesión</p>
      <p class="u-fs-18 u-color-secondary1 u-my-4">
        Te damos la bienvenida al área de cliente de AIG
      </p>
    </div>

    <form class="row" [formGroup]="loginForm">
      <div class="col-12">
        <div class="e-field">
          <label
            for="usuario-field"
            [ngClass]="errorlogin ? 'u-color-warning-error' : ''"
            class="e-field__label"
          >
            Usuario
          </label>
          <input
            type="text"
            [ngClass]="errorlogin ? 'e-field__error' : ''"
            class="e-field__input u-ps-2 u-py-1"
            id="usuario-field"
            formControlName="usuario"
            autocomplete="on"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="e-field">
          <label
            for="contraseña-field"
            [ngClass]="errorlogin ? 'u-color-warning-error' : ''"
            class="e-field__label"
          >
            Contraseña
          </label>
          <div class="p-flexcc">
            <input
              [type]="showPassword ? 'text' : 'password'"
              [ngClass]="errorlogin ? 'e-field__error' : ''"
              class="e-field__input u-ps-2 u-py-1"
              id="contraseña-field"
              formControlName="contraseña"
              autocomplete="off"
            />
            <button
              class="u-pos-absolute u-end-0 u-cursor-pointer u-bg-transparent u-border-none"
              id="viewPassword"
              (click)="showPassword = !showPassword"
            >
              <i
                [ngClass]="showPassword ? 'icon-eye-close' : 'icon-eye-open'"
                class="u-color-secondary1 u-mx-def u-fs-18"
              ></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-12" *ngIf="errorlogin">
        <p class="u-color-warning-error u-mb-def">
          El usuario o la contraseña no son correctos
        </p>
      </div>

      <div class="col-12 p-flexcc u-border-bottom u-pb-def">
        <button
          id="session-btn"
          class="e-btn--primary u-fw-600 u-cursor-pointer aig-login__btn"
          type="submit"
          (click)="sendData()"
          [disabled]="loginForm.invalid"
        >
          Iniciar sesión
        </button>
      </div>
    </form>

    <div class="p-flexcc u-dir-col u-mt-7">
      <!-- ToDo: modal que manda el mail -->
      <p
        (click)="forgetPassword()"
        class="u-color-selected1 u-fs-18 u-cursor-pointer"
      >
        ¿Has olvidado tu contraseña?
      </p>

      <p class="u-fs-16 u-color-secondary1 u-mt-4 u-text-center">
        Si quieres contactar con nosotros puedes escribirnos en
      </p>
      <a href="mailto:backoffice.caixa@icp.es" class="u-color-selected1">
        {{ supportEmail }}
      </a>
    </div>
  </div>
</div>

@if(visibleInsertEmailModal){
<aig-modal-insert-email (hideModal)="CloseModal()"></aig-modal-insert-email>
}
